<template>
	<div>
		<v-card flat color="transparent">
			<v-card-text>
				<v-row align="center">
					<v-col cols="12" md="3" lg="3" class="mx-0 px-0">
						<!-- <v-text-field v-model="tableProps.search" label="Buscar un banco" clearable prepend-inner-icon="mdi-magnify" hide-details></v-text-field> -->
                        <alternativeTextField2
                            @onChanged="(v) => {trySearch(v);}"
                            @onClear="(v) => {trySearch(v);}"
                            :valueInput="tableProps.search"
                            :rule="[]"
                            :placeholder="'Buscar'"
                            :label="''"
                            :clearable="true"
                            :prependInnerIcon="'mdi-magnify'"
                            class="pick-3"
                        ></alternativeTextField2>
					</v-col>
					<v-spacer></v-spacer>
					<v-col   md="5" class="mx-0">
                        <v-row justify="end">
                            <iconButton :props="createBtnData" v-permission="'sale_bills.create'"></iconButton>
                        </v-row>
					</v-col>
				</v-row>
				<v-row>
					<v-col class="mx-0 px-0">
						<datatablePagination :options="options" :total="total"  :props="tableProps" @methodHandler="method_handler" @handleOptions="handleOptions">
							
                        </datatablePagination>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>

        <modal :props="modalProps" @modalResponse="method_handler">
			<!-- Buttons -->
			<template slot="cardActions">
				<v-row justify="end">
					<v-col cols="12" sm="4">
						<secondaryButton
						:props="cancelModal"
						></secondaryButton>
					</v-col>
					<v-col cols="12" sm="4">
						<primaryButton
						:props="acceptModal"
						></primaryButton>
					</v-col>
				</v-row>
			</template> 
		</modal>
		
	</div>
</template>
<script>
import PageStateManager from '../../helpers/PageStateManager';
import ReceiptIcon from '../../assets/receipt.svg';
import Utils from '../../helpers/Utils';
export default {
    data(){
		return {
            options: JSON.parse(PageStateManager.getState(this.$router.history.current.path, 'optionsIndexTable'))??{},
            total: 10,
			search: '',
            selectedID: '',
			actions: [
				{
					name: 'Detalles',
					icon: {
						color: 'secondary',
						icon: 'mdi-information-outline'
					},
					disabled: false,
					type: 'redirect',   //  method, external, redirect
					action: '/obras/1/edicion',
                    permissions: 'sale_bills.show'
				},
				{
					name: 'Editar',
					icon: {
						color: 'secondary',
						icon: 'mdi-pencil-outline'
					},
					disabled: false,
					type: 'redirect',   //  method, external, redirect
					action: '',
                    permissions: 'sale_bills.update'
				},
                {
					name: 'PDF',
					icon: {
						color: 'secondary',
						icon: 'mdi-printer-outline'
					},
					disabled: false,
					type: 'method',   //  method, external, redirect
					action: 'pdf',
                    permissions: 'sale_bills.show',
                    loading: false
				},
				
				{
					name: 'Venta',
					icon: {
						custom: true,
                        color: "secondary",
                        icon: ReceiptIcon,
					},
					disabled: false,
					type: 'redirect',   //  method, external, redirect
					action: '',
                    permissions: 'sale_bills.update'
				},
			],
			tableProps: {
				headers: [
					{
						text: 'Folio',
						align: 'left',
						value: 'folio',
						
						class: 'table-b-border black--text'
					},
					{
						text: 'Fecha',
						align: 'left',
						value: 'date',
						
						class: 'table-b-border black--text'
					},
					{
						text: 'Cliente',
						align: 'left',
						value: 'receiver.name',
						
						class: 'table-b-border black--text'
					},
					{
						text: 'OT',
						align: 'left',
						value: 'reference_name',
						
						class: 'table-b-border black--text'
					},
					{
						text: 'Estatus',
						align: 'left',
						value: 'status',
						
						class: 'table-b-border black--text'
					},
                    
					{
						text: 'ACCIONES',
						align: 'right',
						sortable: false,
						value: 'actions',
						width: '10%',
						class: 'table-b-border black--text'
					}
				],
				items: [],
				search: (JSON.parse(PageStateManager.getState(this.$router.history.current.path, 'optionsIndexTable')))?.search??"",
				loading: false,
                sortBy: 'folio',
                sortDesc: true,
			},
			
			
            createBtnData: {
                hasTooltip:true,
                tooltip: 'Nueva Proforma',
                color:'primary',
                iconColor:'grey darken-3',
                height:'35',
                icon: "mdi-plus",
				to: "SaleBillsCreate",
				block: false,
                click: ()=>{}
            },
            
           
			modalProps: {
				visible: false,
				width: '500',
				title: 'Eliminar',
				text: '¿Estás seguro de eliminar?',
				loading: false,
				bottomLineColor: 'error',
				
			},
			
			cancelModal: {
                text: "No, cancelar",
                icon: "",
				to: "",
				block: true,
				color: '',
                click: ()=>{this.modalProps.visible = false}
            },
			acceptModal: {
                text: "SI, ELIMINAR",
                icon: "",
				to: "",
				block: true,
				color: 'error',
				textColor:'white',
                textColorLevel: '0',
				loading:false,
                click: ()=>{this.delete()}
            },
		}
	},

	mounted(){
		//this.index()
        window.addEventListener('resize', this.onResize, { passive: true });
        this.onResize();
	},

    methods: {
        onResize () {
            
            if(window.innerWidth < 960){
                this.createBtnData.block = true;
            }
            else{
                this.createBtnData.block = false;
            }
        },
        method_handler(object){
            console.log(object);
			this[object.methodName](object.parameters)
		},
        handleOptions(object){
            object.options[`search`] = this.tableProps.search;
			//console.log(object.options);
			this.options = object.options;
            PageStateManager.setState(this.$router.history.current.path, 'optionsIndexTable', JSON.stringify(this.options));
			this.index();
		},
        trySearch(val){
            this.tableProps.search = val;
            this.options.search = val;
            this.options.page = 1;
            PageStateManager.setState(this.$router.history.current.path, 'optionsIndexTable', JSON.stringify(this.options));
            this.index();
        },
		index() {
			this.tableProps.loading = true;
			console.log(this.options.sortBy);
			if(Array.isArray(this.options.sortBy) && this.options.sortBy.length == 0){
				this.options.sortBy.push('created_at');
			}
			let filter = Utils.createFilter(this.options, this.tableProps.headers);
			//call api
			this.$api.saleBill.list(this.$store.state.business, filter)
				.then((resp) =>{
					//console.log(resp);
					this.tableProps.items = resp.data.data.map((x,i) => {
						x['actions'] = JSON.parse(JSON.stringify(this.actions))
                      
						x.actions[0].action = { name: 'SaleBillsDetails', params: { id: x.folio, index:i } }
						x.actions[1].action = { name: 'SaleBillsEdit', params: { id: x.folio, index:i } }
						x.actions[3].action = { name: 'SaleBillsCreateReceivableAccount', params: { id: x.folio, index:i } }

						if(x.status == "TIMBRADO" || x.status == "PAID" || x.status == "CANCELLED"){
							x.actions[1].disabled = true;
							x.actions[3].disabled = true;
						}

						if(x.status == "PAID"){
							x.actions[3].disabled = false;
						}


						x.date = Utils.globalDateFormat(x.date);
						
                        x['parameters'] = { id: x.folio, name: x.folio, index:i};
						x[`receiver.name`] = x?.receiver?.Name??x?.receiver?.name??''

                        x.status = this.getStatus(x.status);

						return x;
					});
                    this.total = resp.data.total
				})
				.catch((error) =>{
					console.log(error);
				})
				.finally(() => {
					this.tableProps.loading = false;
				})
			;
		
		},

        getStatus(value){
            if(value == 'PENDING'){
                return 'Pendiente';
            }
			if(value == 'PAID'){
                return 'Pagado';
            }
			if(value == 'CANCELLED'){
                return 'Cancelado';
            }
            return value;
        },


		deleteItemModal(parameters)
		{
			//console.log(parameters);
			this.acceptModal.text = "SI, ELIMINAR";
            this.cancelModal.text = "No, cancelar";
            this.acceptModal.click = this.delete;
            this.acceptModal.color = 'error';
			this.selectedID = parameters.id;
			this.modalProps = {
				...this.modalProps,
				text: `¿Estás a punto de eliminar ¿deseas continuar?`,
				title: 'Eliminar',
                bottomLineColor: 'error',
			}
            //console.log(this.selectedID)
			this.modalProps.visible = true;
			
		},


		
		pdf(params)
        {

            console.log(params);
            this.tableProps.items[params.index].actions[2].loading = true;
            this.$api.saleBill.pdfQuotation(this.$store.state.business, params.id)
                .then((resp) => {
                    const fileURL = window.URL.createObjectURL(new Blob([resp.data]));
                    const fileLink = document.createElement("a");
                    fileLink.href = fileURL;
                    fileLink.setAttribute(
                    "download",
                    `${params.id}.pdf`
                    );
                    document.body.appendChild(fileLink);
                    fileLink.click();
                })
                .catch((error) => {
                    console.log(error);
					this.$store.dispatch('snackbarError', error.data?.error??'Hubo un problema');
                })
                .finally(() => {
                    this.tableProps.items[params.index].actions[2].loading = false;
                })
            ;
        }


    }
}
</script>